import { useMemo } from 'react'

import type {
  OrganizationInvitation,
  OrganizationMember,
} from '@/components/org-settings/members/members.interface'

import type { ClerkInvitationsResource, ClerkMembershipsResource } from './members-clerk.types'
import { transformInvitation, transformMembership } from './members-transform.helper'

interface UseMembersListProps {
  memberships: ClerkMembershipsResource | null
  invitations: ClerkInvitationsResource | null
  currentUserId: string | null
}

interface UseMembersListReturn {
  memberList: OrganizationMember[]
  invitationList: OrganizationInvitation[]
}

export const useMembersList = ({
  memberships,
  invitations,
  currentUserId,
}: UseMembersListProps): UseMembersListReturn => {
  const memberList = useMemo<OrganizationMember[]>(
    () => (memberships?.data ?? []).map((m) => transformMembership(m, currentUserId)),
    [memberships?.data, currentUserId]
  )

  const invitationList = useMemo<OrganizationInvitation[]>(
    () => (invitations?.data ?? []).map(transformInvitation),
    [invitations?.data]
  )

  return { memberList, invitationList }
}
